module.exports = __webpack_public_path__ + "static/media/andar-bahar.d2bfc069.svg";